<template>
	<div class="course-detail-container">
		<router-view
			v-if="productVariantData"
			:key="$route.params.id" 
			:productVariantData="productVariantData"
			:productVariantId="productVariantId"
		></router-view>
		<div class="minmaxCon"></div>
	</div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { ContentType } from "../../constants/content";

export default {
	name: "CourseDetail",
	data() {
		return {
			productVariantData: null,
		};
	},
	methods: {
		...mapActions("productVariant", ["getProductVariantById"]),
		...mapActions("appState", ["fetchExternalServices"]),

		async loadProductVariant(id) {
			await this.getProductVariantById(id);

			this.productVariantData = this.productVariants.items[id];

			if (this.externalServicesList && !this.externalServicesList[ContentType.EXAM]) {
				this.fetchExternalServices(ContentType.EXAM);
			}
		},
	},
	computed: {
		...mapState("productVariant", ["productVariants", "loading"]),
		...mapState("appState", ["externalServicesList"]),
		productVariantId() {
			return this.$route.params.id;
		},
	},
	created() {
		this.loadProductVariant(this.productVariantId);
	},
	watch: {
		productVariants: function () {
			console.log("productVariantsUpdated");
			if (this.productVariants.items[this.productVariantId]) {
				this.productVariantData =
					this.productVariants.items[this.productVariantId];
			}
		},
		productVariantId(newId) {
			this.loadProductVariant(newId);
		},

	},
};
</script>

<style scoped></style>
